import { getKeywordRegex, parseProvisionVars } from "../../../utils/planUtils";

const Provision = ({ text }) => {
  let parts = []

  const textArray = text.split(/"([^"]*)"/g).filter(s => s.length)
  const matches = text.match(/"([^"]*)"/g).map(s => s.replace(/"/g, ""))
  const labels = text.match(/label "([^"]*)"/g)?.map(s => s.replace("label ", "").replace(/"/g, ""))
  const vars = parseProvisionVars(text)

  const bold = (color) => {
    let style = { fontWeight: 'bold' }
    if (color) style.color = color
    return style
  }

  textArray.map((item, i) => {
    if (matches && matches.includes(item)) {
      if (vars?.includes(item)) {
        parts.push(<span key={i}>"<span style={bold('green')}>{item}</span>"</span>)
      } else if (!labels?.includes(item)) {
        parts.push(<span key={i}>"<span style={bold('blue')}>{item}</span>"</span>)
      } else {
        parts.push(<span key={i}>"{item}"</span>)
      }
    } else {
      const lightArray = item.split(getKeywordRegex('light'))
      const lightMatches = item.match(getKeywordRegex('light'))

      lightArray.forEach((lightItem, j) => {
        if (lightMatches?.includes(lightItem)) {
          parts.push(<span key={`${i}.${j}`} style={bold()}>{lightItem}</span>)
        } else {
          const strongArray = lightItem.split(getKeywordRegex('strong'))
          const strongMatches = lightItem.match(getKeywordRegex('strong'))

          strongArray.forEach((strongItem, k) => {
            if (strongMatches?.includes(strongItem)) {
              parts.push(<span key={`${i}.${j}.${k}`} style={bold('red')}>{strongItem}</span>)
            } else {
              const modifierArray = strongItem.split(getKeywordRegex('modifier'))
              const modifierMatches = strongItem.match(getKeywordRegex('modifier'))

              modifierArray.forEach((modifierItem, l) => {
                if (modifierMatches?.includes(modifierItem)) {
                  parts.push(<span key={`${i}.${j}.${k}.${l}`} style={bold('blue')}>{modifierItem}</span>)
                } else {
                  parts.push(<span key={`${i}.${j}.${k}.${l}`}>{modifierItem}</span>)
                }
              })
            }
          })
        }
      })
    }})

  return <span>{parts}</span>
}

const ProvisionInfo = ({ rider }) => {
  const { inn, oon } = Object.groupBy(rider.provisions, (p) => (p.benefitProvisionText.includes('INN')) ? 'inn' : 'oon')
  return (
    <div>
      <p style={{ fontWeight: 'bold', padding: '1rem 1rem 0rem 1rem' }}>
        {rider.benefitPlanCompName}
      </p>
      <p style={{ padding: '1rem' }}>
        {rider.benefitPlanCompDesc}
      </p>
      {inn &&
       <>
         <p style={{ fontWeight: 'bold', padding: '1rem' }}>INN:</p>
         <ul>
           {inn.map((p, i) => (
             <li key={i} style={{ padding: '0rem 0rem 1rem 0rem'}} >
               <Provision text={p.benefitProvisionText} />
             </li>
           ))}
         </ul>
       </>}
      {oon &&
       <>
         <p style={{ fontWeight: 'bold', padding: '1rem' }}>OON:</p>
         <ul>
           {oon.map((p, i) => (
             <li key={i} style={{ padding: '0rem 0rem 1rem 0rem'}} >
               <Provision text={p.benefitProvisionText} />
             </li>
           ))}
         </ul>
       </>}
    </div>
  )
}

export default ProvisionInfo
